'use client';
import { createMutation } from '@s7/query';
import { compileTemplate } from '../../../common/compileTemplate/compileTemplate.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
class SubscriptionError extends Error {
    constructor(response, data){
        super();
        this.name = 'SubscriptionError';
        this.response = response.clone();
        this.data = data;
        Object.setPrototypeOf(this, SubscriptionError.prototype);
    }
}
const useSubscribeMutation = createMutation(({ email, url, lang = 'ru' })=>({
        query: [
            compileTemplate(url, {
                lang
            }),
            {
                method: 'POST',
                json: {
                    email
                }
            }
        ],
        /* Вместо bad-request для невалидного email приходит ответ со статус-кодом 200. */ transform: /*#__PURE__*/ _async_to_generator(function*(response) {
            var _data_errors;
            const data = yield response.json();
            if (data == null ? void 0 : (_data_errors = data.errors) == null ? void 0 : _data_errors.length) {
                throw new SubscriptionError(response, data);
            }
            return data;
        })
    }));

export { SubscriptionError, useSubscribeMutation };
//# sourceMappingURL=Subscription.js.map
